import { Component, Prop, Vue } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component()
class RouterView extends Vue {
    @ngInject()
    $uiRouter;
    @ngInject()
    $rootScope;

    @Prop({ type: String, default: 'default' })
    name;

    render(h) {
        const child = this.getChild();
        if (child) {
            const component = child.components[this.name];
            if (component) {
                return h(component, {}, this.$slots.default);
            }
        }
        return h();
    }

    getChild() {
        const path = this.$route.matched;
        const parent = this.getParentRoute();
        if (path && parent) {
            const pathIndex = this.findPathIndex(path, parent);
            return pathIndex !== -1 && path.length > pathIndex ? path[pathIndex + 1] : null;
        } else {
            return null;
        }
    }

    getParentRoute() {
        for (let current = this.$parent; current !== current.$root; current = current.$parent) {
            const route = this.detectAngularRoute(current);
            if (route) {
                return route;
            }
        }
    }

    detectAngularRoute(component) {
        const options = component.$options;
        const ctor = options._Ctor[0];
        return ctor.angularRoute;
    }

    findPathIndex(path, item) {
        return path.findIndex(route => route.name === item.name);
    }
}

export default RouterView;
